import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";
import UserNavbar from "./GuestNavbar";

const GuestLayout = () => {
  return (
    <Box sx={{ 
      minHeight: "100vh",
      backgroundColor: "#f8fafc",
      display: "flex",
      flexDirection: "column"
    }}>
      <UserNavbar />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          py: 3,
          px: { xs: 2, sm: 3, md: 4 },
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          backgroundAttachment: "fixed",
          minHeight: "calc(100vh - 64px)"
        }}
      >
        <Container 
          maxWidth="xl" 
          sx={{ 
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)",
            backdropFilter: "blur(10px)",
            p: { xs: 2, sm: 3, md: 4 },
            minHeight: "calc(100vh - 120px)"
          }}
        >
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default GuestLayout;
